<template>
  <div class="protocol">
    <!-- <navigator title="发帖规则" :routePath='"/bbs/publish"'></navigator> -->

    <div class="comtent">
      <Detail></Detail>
    </div>

    <div class="footer">
      <van-button class='back' text='返回' @click='back'/>
    </div>

  </div>
</template>

<script>
import Detail from './ProtocolDetail';
export default {
  methods: {
    back() {
      this.$router.push('/bbs/publish');
    },
  },
  components: { Detail },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.footer{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  .back {
    width: 100%;
    height: 1.04rem;
    line-height: 1.04rem;
    background: $color-main;
    color: #fff;
    font-size: .48rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bbs/components/Protocol.vue